export var CollectionMenuViewStyle;
(function (CollectionMenuViewStyle) {
    CollectionMenuViewStyle["Simple"] = "simple";
    CollectionMenuViewStyle["Collapsible"] = "collapsible";
    CollectionMenuViewStyle["Heading"] = "heading";
})(CollectionMenuViewStyle || (CollectionMenuViewStyle = {}));
//# sourceMappingURL=types.js.map